import { createFileRoute, redirect } from '@tanstack/react-router';
import ExecutivePage from '../pages/ExecutivePage';
import { getProfileSync } from '../lib/getProfileSync';

export const Route = createFileRoute('/executive')({
  beforeLoad: () => {
    const profile = getProfileSync();
    if (!profile || profile.status !== 'active') {
      throw redirect({ to: '/' });
    }
    if (!['Executive', 'Admin'].includes(profile.role)) {
      throw redirect({ to: '/' });
    }
  },
  component: ExecutivePage,
});
